<template>
<div id="app">
 
  <div class="container">
    <div class="columns">
      <div class="column is-narrow">
        <Sidebar/>
      </div>
      <div class="column ">
         <router-view/>
      </div> 
    </div>
  </div>
</div>
</template>


<script>
import Sidebar from "@/components/Sidebar";

export default {
  name: "App",
  data() {
    return {
    }
  },
  components: {Sidebar},
  mounted() {
    let loggedIn = localStorage.getItem("user");
    if (!loggedIn) {
      this.$router.replace({name:"Login"});
    }
    
  },
  methods: {
     setAuthenticated(status) {
                this.$store.state.authenticated = status;
            },
            logout() {
                this.$store.state.authenticated = false;
            }
  },
    }
</script>

<style>
.container {
    max-width: 95%;
}
</style>